import React from 'react';

// 3rd party components
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListSubheader from '@mui/material/ListSubheader';

// i18n
import { useTranslations } from '../context/TranslationsContext';

const Dropdown = (props) => {
    const { t } = useTranslations();

    const {
        invalid,
        placeholder,
        value,
        label,
        source,
        onChange: handleChange,
        modify,
        internExtern = false,
        compact = false,
    } = props;

    let extern = true;

    return (
        <FormControl sx={{ width: '100%' }} size={compact ? 'small' : 'medium'} error={!!invalid}>
            <InputLabel style={{ fontFamily: 'RalewayRegular' }}>
                {placeholder}
            </InputLabel>

            <Select
                value={value}
                label={compact ? placeholder : label}
                onChange={handleChange}
                SelectDisplayProps={compact ? {
                    title: source.find((option) => String(option.value) === String(value))?.label,
                    'aria-label': placeholder,
                } : undefined}
                MenuProps={compact ? {
                    slotProps: {
                        paper: {
                            sx: {
                                maxHeight: 320,
                                maxWidth: 'min(360px, calc(100% - 32px))',
                                '& .MuiMenuItem-root': {
                                    whiteSpace: 'normal',
                                    overflowWrap: 'anywhere',
                                    fontSize: 14,
                                },
                            },
                        },
                    },
                } : undefined}
            >
                {internExtern && (
                    <ListSubheader className="intern-extern">
                        {t('intern', 'Intern')}
                    </ListSubheader>
                )}

                {source.length > 0 ? (
                    source.map((option, index) => {
                        if (option.actief) {
                            const items = [];

                            // Eerste keer dat we een externe option tegenkomen: extern-header toevoegen
                            if (option.extern === 1 && extern && internExtern) {
                                extern = false;
                                items.push(
                                    <ListSubheader
                                        key={`extern-header-${index}`}
                                        className="intern-extern"
                                    >
                                        {t('extern', 'Extern')}
                                    </ListSubheader>
                                );
                            }

                            items.push(
                                <MenuItem
                                    key={`option-${index}`}
                                    value={option.value}
                                    style={{ fontFamily: 'RalewayRegular' }}
                                >
                                    {option.label}
                                </MenuItem>
                            );

                            return items;
                        } else if (modify && !option.actief) {
                            return (
                                <MenuItem
                                    key={`option-${index}`}
                                    value={option.value}
                                    style={{ fontFamily: 'RalewayRegular' }}
                                    disabled
                                >
                                    {option.label}
                                </MenuItem>
                            );
                        }

                        return null;
                    })
                ) : (
                    <MenuItem disabled className="no-options">
                        {t('no_options_found', 'No options found...')}
                    </MenuItem>
                )}
            </Select>
        </FormControl>
    );
};

export default Dropdown;
